export const TEST_ID = 'linkedEntitiesAccordion';
